import { Note, useWidgetText } from "../shared";
import type { WidgetState } from "../types";

/** The line under a control that says why it looks the way it does. */
export function ControlNotes({ state, offline }: { state: WidgetState; offline: boolean }) {
  const { t } = useWidgetText();
  return (
    <>
      {offline && <Note tone="warn">{t("state.offline")}</Note>}
      {state === "pending" && <Note>{t("state.waiting")}</Note>}
      {state === "failed" && <Note tone="warn">{t("state.failed")}</Note>}
      {state === "read_only" && <Note>{t("state.noPermission")}</Note>}
    </>
  );
}
